$shm_projects_catalog $mol_book2
	projects_list_visible? true
	new_project_opened? false
	new_project_title? \
	filter? \
	project_selected \
	project_settings_content /$mol_view_content
	add? null
	pages <= catalog_pages /
	Menu_page $mol_page
		title \Проекты
		head /
			<= List_head $shm_projects_catalog_head
				title \Проекты
				title_uri <= projects_uri \
				filter? <=> filter? \
				add? <=> add? null
				settings_hint \Настройки Codex
				settings_content <= project_settings_content
				Close null
		body /
			<= Projects $shm_tree
				roots <= project_roots /
				children* <= project_children* /
				expanded*? <=> project_expanded*? true
				expanded_key* <= project_expanded_key* \
				Item* <= Project_link*
	New_project_page $mol_page
		title \Новый проект
		body /
			<= New_project_form $mol_view
				sub /
					<= New_project_title_field $mol_form_field
						name \Название проекта
						Content <= New_project_title $mol_string
							value? <=> new_project_title? \
					<= New_project_actions $mol_view
						sub /
							<= New_project_create $mol_button_major
								title \Создать
								enabled <= new_project_create_enabled true
								click? <=> new_project_create? null
							<= New_project_cancel $mol_button_minor
								title \Отмена
								click? <=> new_project_cancel? null
	Catalog_page $mol_page
		title \Проекты
		body /
			<= Catalog_scroll $mol_scroll
				sub /
					<= Catalog_content $mol_view
						sub /
							<= Timeline $mol_view
								sub /
									<= Timeline_title $mol_view
										sub / \Пререлизы за последние 14 дней
									<= Timeline_days $mol_view
										sub <= timeline_day_rows /
							<= Project_table $mol_view
								sub /
									<= Project_table_head $mol_view
										sub /
											<= Project_head_title $mol_view
												sub / \Проект
											<= Project_head_version $mol_view
												sub / \Версия
											<= Project_head_prerelease $mol_view
												sub / \Пререлиз
											<= Project_head_release $mol_view
												sub / \Релиз
											<= Project_head_date $mol_view
												sub / \Обновлён
									<= Project_rows $mol_list
										rows <= project_table_rows /
	Timeline_day* $mol_view
		sub /
			<= Timeline_day_title* $mol_view
				sub / <= timeline_day_title* \
			<= Timeline_events* $mol_view
				sub <= timeline_event_rows* /
	Timeline_event* $mol_link
		arg <= timeline_event_arg* *
		title <= timeline_event_title* \
		sub / <= timeline_event_title* \
	Timeline_empty* $mol_view
		sub / \—
	Project_row* $mol_view
		sub /
			<= Project_row_title* $mol_link
				arg <= project_arg* *
				title <= project_title* \
				sub / <= project_title* \
			<= Project_row_version* $mol_link
				arg <= project_version_arg* *
				title <= project_version* \
				sub / <= project_version* \
			<= Project_row_prerelease* $mol_view
				sub / <= project_prerelease* \
			<= Project_row_release* $mol_view
				sub / <= project_release* \
			<= Project_row_date* $mol_view
				sub / <= project_version_date* \
	Project_link* $mol_link
		arg <= project_arg* *
		current <= project_current* false
		title <= project_title* \
		click? <=> project_read*? null
		sub /
			<= Project_label* $mol_view
				sub /
					<= Project_title_row* $mol_view
						sub /
							<= Project_activity* $mol_view
								attr *
									^
									title <= project_activity_title* \
									data-status <= project_activity_status* \
								sub <= project_activity_content* /
							<= Project_title* $mol_view
								sub / <= project_title* \
					<= Project_id* $mol_view
						sub / <= project_identifier* \
	Project* $shm_projects_page
		project_id <= project_id* \
